import React from "react"
import CustomPaper from "../../../../ui/molecules/CustomPaper"
import { CustomCol, CustomRow } from "../../../../ui/spacings"
import OrderRecap from "../../../checkout/components/common/OrderRecapBox"
import { Basket } from "../../../checkout/state/checkoutTypes"
import { CompletedOrder } from "../../types"
import { hasPendingPayment, isRefundable } from "../../utils/returns"
import EditOrderPendingPayment from "../EditOrderPendingPayment"
import ReturnPanel from "../ReturnPanel"
import OrderInfoData from "./OrderInfoData"

interface Props {
  order: CompletedOrder
}

const toBasket = (order: CompletedOrder): Basket =>
  ({
    ...order,
    order: {
      id: order.id,
    },
  } as any)

const OrderDetailsPanelContent = ({ order }: Props) => {
  return (
    <>
      <CustomRow spacing>
        <CustomCol xs={12} sm={7}>
          <CustomPaper className="my-6 sm:mt-2">
            <OrderInfoData order={order} />
            {hasPendingPayment(order) && (
              <div className="my-4">
                <EditOrderPendingPayment order={order} />
              </div>
            )}
            {!hasPendingPayment(order) && isRefundable(order) && (
              <div className="mt-4">
                <ReturnPanel order={order} />
              </div>
            )}
          </CustomPaper>
        </CustomCol>
        <CustomCol xs={12} sm={5}>
          <CustomPaper className="mt-2 mb-6">
            <OrderRecap basket={toBasket(order)} />
          </CustomPaper>
        </CustomCol>
      </CustomRow>
    </>
  )
}

export default OrderDetailsPanelContent
